import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';

import Box from '@mui/material/Box';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const UserText = superstyled({
  tag: Text,
  styles: {
    fontWeight: 'bold',
    marginBottom: '0.5rem'
  }
});
export const TitleText = superstyled({
  tag: Text,
  styles: {
    fontWeight: 'normal'
  }
});

export const HeaderUser = superstyled({
  tag: Text,
  styles: {
    fontWeight: 'bold',
    marginBottom: '0.5rem'
  }
});

export const HeaderText = superstyled(
  {
    tag: Text,
    styles: {
      fontWeight: 'normal'
    }
  }
);

export const HeaderTitleUser = superstyled({
  tag: Title,
  styles: {
    fontWeight: 'bold',
    marginBottom: '0.5rem'
  }
});

export const HeaderTitleText = superstyled(
  {
    tag: Title,
    styles: {
      fontWeight: 'normal'
    }
  }
);

export const HeaderBox = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    padding: '2.5rem 1.5rem',
    borderRadius: '1rem',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem 1rem'
    }
  })
});
export const ItemBox = superstyled({
  Box,
  propsAdded: ['bgcolor'],
  styles: ({ bgColor, theme }) => ({
    padding: '1.5rem 0',
    borderRadius: '1rem',
    backgroundColor: bgColor,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem 0'
    }
  })
});
